import { User } from './generic.model';

export class Stage {
    Id: number;
    SupplierCode: string;
    Name: string;
    Status: StageStatus;
    StatusDescription: string;
    Comment: string;
    ApproverRoles: any;
    Properties: StageProperty[];
    CreatedByUser: User;
    CreatedTimeStamp: string;
    ModifiedByUser: User;
    ModifiedTimeStamp: Date;
}
export class StageDetails {
    SupplierCode: string;
    Name: string;
    Property: StageProperty[];
    Status: StageStatus;
    StatusDescription: string;
}
export enum StageStatus {
    Requested = 'Requested',
    Approved = 'Approved',
    Completed = 'Completed',
    NeedMoreInfo = 'NeedMoreInfo',
    Rejected = 'Rejected'
}


export class StageProperty {
    type: Tab;
    oldValue: any;
    newValue: any;
}

export class Tabs {
    type: Tab;
    icon: string;
    path: string;
    label: string;
    disabled: boolean;
    highlight: boolean;
    visited: boolean;
}

export enum Tab {
    Detail = 'Details',
    Address = 'Address',
    Contact = 'Contact',
    Bank = 'Bank',
    Tax = 'Tax',
    Document = 'Document',
    Entity = 'Entity',
    Validation = 'Validation',
    Audit = 'Audit',
    PO = 'PO',
    Part = 'PartNumber',
    EHS ='EHS'
}